import { i18n as translate } from './translate';

translate.loadTranslations();

export const i18n = translate;
